import script from "./CommonConfirmDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonConfirmDialog.vue?vue&type=script&setup=true&lang=js"

import "./CommonConfirmDialog.vue?vue&type=style&index=0&id=2db3c41c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2db3c41c"]])

export default __exports__